export var colors = {
    cyan: '#98d9f0',
    green: '#3f9c35',
    landGreen: '#36842D',
    blue: '#003591',
    skyBlue: '#99D9F0',
    seaBlue: '#003591',
    darkBlue: '#0f204b',
    digitalBlue: '#0067C5',
    neutral: '#F2F2F2',
    yellow: '#FECB00',
    red: '#C4262E'
};
